export const USAGE_LINK_COPY_ALLOWED_STATUSES = [
  "ACTIVE",
] as const;

export function isUsageLinkCopyAllowed(status?: string | null) {
  if (!status) return false;
  return USAGE_LINK_COPY_ALLOWED_STATUSES.includes(
    status.toUpperCase() as (typeof USAGE_LINK_COPY_ALLOWED_STATUSES)[number],
  );
}

export function getUsageLinkCopyNotAllowedMessage(status?: string | null) {
  return "Link copying is allowed only for Active bundle";
}
